const meta = {
  'event-limits': 'Events',
  'trace-limits': 'Traces',
  'metric-limits': 'Metrics',
  'query-limits': 'Queries',
};

export default meta;
